import Vue from 'vue'
import RouterStorage from 'vue-router-storage'

Vue.use(RouterStorage, { showLog: false, stayHere: true , instanceName: '$history' });